import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Client } from './client';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ProductsVisibilityPermissionsService {

  constructor( private http: HttpClient,
               private client: Client ) { }

    getProductsVisibilityPermissions (service_id): Observable<any> {
        return this.http.get(this.client.getFaresUrl() + '/visibility-permissions' + '?service=' + service_id);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/products-visibility-permissions.service.ts